import api from '../../seller-apis/api';
import servicesApi from '../../seller-apis/servicesApi';
import { GenUtilities } from '../../utilities/GenUtilities';
import { validations } from '../../Validations/Profile';
import axios from 'axios';
export const fetchProfile = async (dispatch) => {
    try {
        dispatch({
            type: "FETCH_PROFILE"
        })
        const res = await api.auth.me()
        console.log(res)
        dispatch({
            type: "FETCH_PROFILE_SUCCESS",
            payload: { "data": res.data, "msg": res.message }
        })
    }
    catch (error) {
        const errorMsg = error
        dispatch({
            type: "FETCH_PROFILE_ERROR",
            payload: errorMsg
        })
    }
}

export const updatePic = async (dispatch, data) => {
    try {

            dispatch({
                type: "UPDATE_PROFILE_PIC",
            })
            let { status, msg } = validations.profilePicUpload(data.file);
            if (!status) {
                throw msg;
            }
            let imageName = GenUtilities.removeSpacesFromName("img_" + data.sellerId + "_" + data.file[0].name);
            let res1 = await servicesApi.saveImage({ "imageName": imageName, "type": "avatar"});
             let res2 =   axios({
                    method: 'put',
                    url: res1.data,
                    data: data.file[0]
                }).catch(error => {
                    throw error
                });
            let res3 = await api.seller.updatePicture({ "avatar": imageName });
            localStorage.setItem("image",imageName);
            setTimeout(() => {
                dispatch({
                    type: "UPDATE_PROFILE_PIC_SUCCESS",
                    payload: imageName
                })
                dispatch({
                    type:"UPDATE_PIC_",
                    payload:imageName
                })
            }, 1000)
    }
    catch (error) {
        dispatch({
            type: "UPDATE_PROFILE_PIC_ERROR",
            payload: error
        })
    }
    
}

export const fetchSellerAddress = async (dispatch, data) => {
    try {
        dispatch({
            type: "FETCH_SELLER_ADDRESS",
        })
        let addressBody = {
            "filter": {},
            "excludeField": {},
            "pageNo": 1,
            "sortFilter": {},
        }
        const res = await api.seller.getSellerAddress(addressBody);
        dispatch({
            type: "FETCH_SELLER_ADDRESS_SUCCESS",
            payload: res.data
        })
    }
    catch (error) {
        dispatch({
            type: "FETCH_SELLER_ADDRESS_ERROR",
            payload: error
        })
    }
}

export const deleteSellerAddress = async (dispatch, data) => {
    try {
        const res = api.seller.deleteSellerAddress(data.id);
        dispatch({
            type: "DELETE_SELLER_ADDRESS_SUCCESS",
            payload: data.index
        })
    }
    catch (error) {
        dispatch({
            type: "DELETE_SELLER_ADDRESS_ERROR",
            payload: error
        })
    }
}

// sl-828
export const updateSellerProfileOkStatus = async(dispatch, data) => {
      dispatch({
            type: "UPDATE_SELLER_PROFILE_OK_STATUS",
            payload: data
        })
}